export function createLoadMoreRequest(status, count, skip) {
    const result = {
        filter: {
            status
        },
        pagination: {
            count,
            skip
        }
    };
    return result;
}
//# sourceMappingURL=createLoadMoreRequest.js.map